<mat-menu #uploadMenu="matMenu">
  @if (!hideUploadFromGallery) {
    <button
      *ffdIfRole="['internal-provider']"
      class="flex justify-between gap-4 font-medium text-text-primary"
      (click)="onAddFromGalleryClick()"
    >
      <span>{{ 'collab_chat_menu_add_from_image_gallery' | translate }}</span>
      <svg-icon class="shrink-0" size="md" key="px-24-ffd-images"></svg-icon>
    </button>
    <hr class="border-text-white" />
  }
  <button class="flex justify-between gap-4 font-medium text-text-primary" (click)="onUploadClick()">
    <span>{{ 'collab_chat_menu_upload' | translate }}</span>
    <svg-icon class="shrink-0" size="md" key="px-24-upload"></svg-icon>
  </button>
</mat-menu>
<button
  class="mb-1 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-background-light-blue"
  [matMenuTriggerFor]="uploadMenu"
  [disabled]="!isDictationIdle() || isGeneratingSignal()"
>
  <svg-icon class="text-primary-blue" size="sm" key="px-16-plus"></svg-icon>
</button>
<input #imageUploader class="hidden" type="file" multiple (change)="onUpload($event)" [accept]="acceptedMimeTypes" />

<button class="flex h-10 shrink-0 items-center" [disabled]="!isDictationIdle() || isGeneratingSignal()" (click)="onRecordClick()">
  @if (recordingStatus() === 'recording') {
    <div class="flex items-center gap-2">
      <h6 class="w-10 text-h7 font-light">{{ recordCounter() | secondsToTime }}</h6>
      <svg-icon key="px-40-stop-new" size="lg"></svg-icon>
    </div>
  } @else if (recordingStatus() === 'stopped') {
    <svg-icon
      [ngClass]="{
        'text-text-extra-light': !isDictationIdle()
      }"
      key="px-40-record-new"
      size="lg"
    ></svg-icon>
  } @else {
    <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions" size="lg"></ng-lottie>
  }
</button>

<div class="relative flex grow">
  <div
    class="enhance-toolbar absolute -top-10 right-0 flex h-10 items-center justify-center gap-1 rounded-2xl rounded-br-none border border-b-0 border-states-purple/20 bg-other-toolbar-purple p-1"
  >
    @if (isEnhanceToolbarOpen()) {
      <button
        type="button"
        class="flex items-center justify-center gap-1 self-stretch overflow-hidden rounded-xl bg-background-white px-4 py-1 text-states-purple transition-colors disabled:bg-other-enhancement disabled:opacity-40"
        [ngClass]="{
          'outline outline-other-toolbar-purple': selectedEnhanceButton() === enhanceMessagePromptType.REWRITE
        }"
        (click)="onEnhanceMessageClick(enhanceMessagePromptType.REWRITE)"
        [disabled]="!isEnhanceToolbarActive()"
      >
        <svg-icon class="h-8 w-8 shrink-0" key="px-16-enhance-2" [fontSize]="16"></svg-icon>
        <span class="typo-h5-semibold">{{ 'collab_enhance_rewrite_button' | translate }}</span>
      </button>
      <button
        type="button"
        class="flex items-center justify-center gap-1 self-stretch overflow-hidden rounded-xl bg-background-white px-4 py-1 text-states-purple transition-colors disabled:bg-other-enhancement disabled:opacity-40"
        [ngClass]="{
          'outline outline-other-toolbar-purple': selectedEnhanceButton() === enhanceMessagePromptType.CONCISE
        }"
        (click)="onEnhanceMessageClick(enhanceMessagePromptType.CONCISE)"
        [disabled]="!isEnhanceToolbarActive()"
      >
        <svg-icon class="h-8 w-8 shrink-0" key="px-16-concise" [fontSize]="16"></svg-icon>
        <span class="typo-h5-semibold">{{ 'collab_enhance_concise_button' | translate }}</span>
      </button>

      <button
        type="button"
        class="group z-10 flex h-full items-center justify-center gap-2 rounded-xl bg-background-white px-4 py-1 transition-colors disabled:bg-other-enhancement disabled:opacity-40"
        [ngClass]="{
          'outline outline-other-toolbar-purple': selectedEnhanceButton() === enhanceMessagePromptType.BULLETS && isGeneratingSignal()
        }"
        (click)="onEnhanceMessageClick(enhanceMessagePromptType.BULLETS)"
        [disabled]="!isEnhanceToolbarActive()"
      >
        <svg-icon class="h-8 w-8 shrink-0 text-states-purple" key="px-20-bullet-list" [fontSize]="16"></svg-icon>
        <span class="typo-h5-semibold text-states-purple">{{ 'collab_enhance_bullets_button' | translate }}</span>
      </button>

      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center overflow-hidden text-states-purple disabled:text-other-toolbar-purple"
        (click)="onUndoClick()"
        [disabled]="!isDictationIdle() || isGeneratingSignal() || isUndoDisabledSignal()"
      >
        <svg-icon key="px-24-undo" [style.width]="'20px'" [style.height]="'20px'"></svg-icon>
      </button>
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center overflow-hidden text-states-purple disabled:text-other-toolbar-purple"
        (click)="onRedoClick()"
        [disabled]="!isDictationIdle() || isGeneratingSignal() || isRedoDisabledSignal()"
      >
        <svg-icon key="px-24-redo" [style.width]="'20px'" [style.height]="'20px'"></svg-icon>
      </button>
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center overflow-hidden rounded-xl py-0 text-states-purple disabled:bg-other-voice-control disabled:opacity-40"
        [disabled]="!isDictationIdle() || isGeneratingSignal()"
        (click)="onEnhanceToolbarClose()"
      >
        <svg-icon key="px-24-x" [style.width]="'20px'" [style.height]="'20px'"></svg-icon>
      </button>
    } @else {
      <button
        type="button"
        class="flex h-8 w-8 items-center justify-center overflow-hidden rounded-xl py-0 text-states-purple"
        (click)="onEnhanceToolbarClick()"
      >
        <svg-icon key="px-20-ai" [style.width]="'20px'" [style.height]="'20px'"></svg-icon>
      </button>
    }
  </div>

  <div
    class="relative z-20 flex min-h-10 w-full items-center justify-between overflow-hidden rounded-2xl border border-text-extra-light bg-background-white px-3 py-2 text-text-primary"
    [ngClass]="!isDictationIdle() ? 'border-states-purple focus-within:border-states-purple' : 'focus-within:border-primary-blue'"
  >
    <lib-voice-typing-text-field
      class="max-h-[250px] w-full overflow-auto"
      #voiceTypingTextField
      [value]="messageSignal()"
      [lastFocusedCursorOffset]="lastFocusedCursorOffsetSignal()"
      (lastFocusedCursorOffsetChange)="updateLastFocusedCursorOffset($event)"
      [transcriptionFormControl]="transcription"
      [transcriptionStatus$]="transcriptionStatus$"
      [isRecording]="transcriptionStatus() === 'recording'"
      [isRecordingLoading]="transcriptionStatus() === 'loading'"
      (manualTypeKeyUp)="onMessageChange($event)"
      (recordingLoading)="onRecordingLoading($event)"
      [placeholder]="'collab_input_field_placeholder' | translate"
      [sendOnEnter]="true"
      [lineBreakOnShiftEnter]="true"
      (enterKeydown)="onSubmit()"
      [contextMenuHeaderConfig]="contextMenuHeaderConfig()"
      (generateText)="onGenerateTextFromContextMenu($event)"
    ></lib-voice-typing-text-field>
    <div class="relative flex h-full items-end gap-2" rightIcon>
      @if (transcriptionStatus() === 'idle') {
        <button
          class="flex h-6 w-full items-center rounded-lg text-states-purple"
          [class.text-states-purple]="recordingStatus() === 'stopped'"
          [class.text-text-light]="recordingStatus() === 'recording' || recordingStatus() === 'pending'"
          [class.cursor-default]="recordingStatus() === 'recording' || recordingStatus() === 'pending'"
          [disabled]="isGeneratingSignal()"
          (click)="onDictationClick()"
        >
          <svg-icon class="min-h-[24px] min-w-[24px]" key="px-40-voice-v-2" size="md"></svg-icon>
        </button>
      }

      @if (transcriptionStatus() === 'loading') {
        <div class="flex h-6 w-6 items-center justify-center text-states-purple">
          <ng-lottie class="h-4 w-4" currentcolor [options]="lottieOptions"></ng-lottie>
        </div>
      }

      @if (transcriptionStatus() === 'recording') {
        <ffd-audio-input-dropdown
          class="flex h-6 items-center"
          [activeDeviceId]="activeDeviceId()"
          (selectDevice)="onSelectDevice($event)"
        ></ffd-audio-input-dropdown>
        <div class="-mr-2 flex h-6 items-center">
          <button class="flex h-8 w-8 items-center justify-center rounded-[14px] bg-states-purple" (click)="onDictationClick()">
            <svg-icon class="max-h-[12px] max-w-[12px] text-text-white" key="px-12-stop"></svg-icon>
          </button>
        </div>
      }
    </div>
  </div>
</div>

<button (click)="onSubmit()" class="flex h-10 items-center" rightIcon [disabled]="!(isSendActive() && isDictationIdle())">
  <svg-icon
    [class]="isSendActive() && isDictationIdle() ? 'text-primary-blue' : 'text-text-extra-light'"
    key="px-24-send"
    size="lg"
    rightIcon
  ></svg-icon>
</button>

<div class="col-span-2 col-start-2 flex gap-3 overflow-auto pt-0.5">
  @if (attachmentsSignal().fullSeries; as fullSeries) {
    <div class="relative col-start-1 row-start-1 h-26 w-26">
      <button
        class="pointer-events-auto absolute -right-0.5 -top-0.5 z-20 inline-flex rounded-full border border-text-white bg-text-black"
        (click)="onFullSeriesDeleteClick($event, fullSeries)"
      >
        <svg-icon key="px-12-x" size="xs" class="text-text-white"></svg-icon>
      </button>
      <lib-attachment class="h-26 w-26" [size]="'square'" (click)="onAddFromGalleryClick()">
        <lib-full-series-preview class="flex h-full items-center" [fullSeries]="fullSeries" />
        <div details class="typo-h8-light flex flex-shrink-0 justify-between px-2 py-[5px] text-text-primary">
          <span class="typo-h8-light">{{ 'collab_attachment_full_series' | translate }}</span>
        </div>
      </lib-attachment>
    </div>
  }
  @for (attachment of attachmentsSignal().uncategorized; track attachment.url) {
    <div class="relative col-start-1 row-start-1 h-26 w-26">
      <button
        class="pointer-events-auto absolute -right-0.5 -top-0.5 z-20 inline-flex rounded-full border border-text-white bg-text-black"
        (click)="onAttachmentDeleteClick($event, [attachment])"
      >
        <svg-icon key="px-12-x" size="xs" class="text-text-white"></svg-icon>
      </button>
      <lib-attachment class="h-26 w-26 shrink-0" [size]="'square'">
        @if (attachment.url && attachment.file) {
          @switch (attachment.mediaType) {
            @case (MediaType.IMAGE) {
              <button [libPreviewImage]="attachment.url">
                <img crossorigin="anonymous" class="h-full w-full rounded-2xl object-cover" [src]="attachment.url" />
              </button>
            }
            @case (MediaType.RECORDING) {
              <button
                class="relative grid h-full w-full items-center"
                libPreviewVideo
                [videoUrl]="attachment.url"
                [fileType]="attachment.file.type"
              >
                <div class="absolute left-0 top-0 z-10 h-full w-full bg-text-extra-light/20"></div>
                <video
                  crossorigin="anonymous"
                  class="pointer-events-none absolute left-0 top-0 col-start-1 row-start-1 h-full w-full rounded-2xl object-cover"
                  [src]="attachment.url"
                ></video>
                <svg-icon class="z-20 col-start-1 row-start-1 place-self-center" key="px-40-play-white" size="md"></svg-icon>
              </button>
            }
          }
        }

        <div details class="flex justify-between px-2 py-[2px]" [style.zoom.%]="90">
          <div class="flex-shrink-0 text-[10px] font-semibold text-text-primary">
            {{ attachment.date | date: 'dd MMM, YYYY' }}
          </div>
          <div class="flex-shrink-0 text-[10px] font-light text-text-tertiary">
            @if (attachment.toothPositionString) {
              #{{ attachment.toothPositionString }}
            }
          </div>
        </div>
      </lib-attachment>
    </div>
  }
</div>
